import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { colors } from '@prisjakt/ui-base/styles/variables';

const lineThickness = 3; // px
const dotSize = 17; // px
const handleColor = colors.darkGray1;
const numberColor = colors.darkGray4;
const numberColorInactive = colors.darkGray1;
const textColor = colors.darkGray4;
const textBorder = colors.darkGray1;
const textBorderInvalid = colors.darkGray1;
const textBackgroundInvalid = colors.darkGray1;
const barActive = colors.darkBlue1;
const barInactive = colors.lightGray2;

export const Layout = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
  display: flex;
  flex-flow: ${ifProp({ layout: 'horizontal' }, 'row', 'column')};
  ${({ layout }) =>
    layout === 'horizontal' &&
    css`
      margin-top: 0;
      margin-bottom: 10px;
    `}
`;

export const SliderWrapper = styled.div`
  flex: 1;
  margin: 0 20px 15px;
  margin-top: ${({ showBars }) => (showBars ? '0px' : '15px')};
`;

export const Bars = styled.div`
  width: 100%;
  height: ${ifProp({ layout: 'horizontal' }, 13, 25)}px;
  margin-top: 5px;
  display: flex;
`;

export const Bar = styled.div`
  flex: 1;
  position: relative;
  padding: 3px 1px 0 1px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: flex-end;
  cursor: pointer;

  ${props =>
    props.inactive &&
    css`
      width: 100%;
      height: 100%;
      background-color: ${barInactive};
    `}
`;

export const Filler = styled.div`
  position: relative;
  background-color: ${barActive};
  width: 100%;
  max-width: 30px;
  margin: 0 auto;
  min-height: ${({ empty }) => (empty ? 0 : '2px')};
  transition: height 0.3s ease;
`;

export const Handles = styled.div`
  position: relative;
`;

export const Handle = styled.div`
  touch-action: pan-y;
  position: absolute;
  z-index: 1;
  display: inline-flex;
  width: 30px;
  height: 30px;
  padding-top: 5px;
  justify-content: center;
  cursor: pointer;
  opacity: ${ifProp('invalid', 0.4, 1)};
  left: ${ifProp({ direction: 'from' }, 0, 100)}%;
  transform: translateX(-50%) translateY(-${dotSize - lineThickness}px);
  transition: ${ifProp('dragging', 'none', 'all 0.2s ease')};
`;

export const HandleDot = styled.div`
  border-radius: 50%;
  width: ${dotSize}px;
  height: ${dotSize}px;
  background-color: ${colors.white};
  border: 1px solid ${handleColor};
  ${({ selected, dragging }) =>
    (selected || dragging) &&
    css`
      border-color: ${colors.white};
      background-color: ${colors.lightBlue1};
    `}
`;

export const LineWrapper = styled.div`
  position: relative;
  height: ${ifProp({ layout: 'horizontal' }, 1, lineThickness)}px;
  background-color: ${colors.lightGray2};
`;

export const Line = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.darkBlue1};
  display: ${({ invalid }) => (invalid ? 'none' : 'block')};
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const Number = styled.div`
  position: relative;
  font-size: 11px;
  color: ${numberColor};
  margin-top: ${ifProp({ layout: 'horizontal' }, 3, 6)}px;
`;

export const NumberValue = styled.button`
  position: absolute;
  text-align: center;
  transform: translateX(-50%);
  cursor: pointer;
  padding: 5px 0;
  ${({ inactive }) =>
    inactive &&
    css`
      color: ${numberColorInactive};
    `}
`;

export const Input = styled.input`
  width: 70px;
  text-align: center;
  color: ${textColor};
  border: 1px solid ${textBorder};
  border-radius: 2px;
  font-size: 12px;
  ${({ invalid }) =>
    invalid &&
    css`
      border-color: ${textBorderInvalid};
      background-color: ${textBackgroundInvalid}];
    `}
`;

export const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-self: center;
  ${({ layout }) =>
    layout === 'horizontal' &&
    css`
      width: 180px;
      order: 2;
    `};
`;
